  (function() {
    'use strict';

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartNoteFix);
    } else {
      initCartNoteFix();
    }

    function initCartNoteFix() {
      const noteField = document.getElementById('cart-note');
      const checkoutButtons = document.querySelectorAll('button[name="checkout"]');

      if (!noteField || checkoutButtons.length === 0) {
        return;
      }

      checkoutButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          const noteValue = noteField.value.trim();

          if (noteValue) {
            e.preventDefault();
            e.stopPropagation();
            // Save and redirect to checkout
            saveCartNote(noteValue, true);
          }
        });
      });

      // Auto-save note when field loses focus (but don't redirect)
      noteField.addEventListener('blur', function() {
        const noteValue = this.value.trim();
        if (noteValue) {
          // Save silently without redirecting
          saveCartNote(noteValue, false);
        }
      });
    }

    function saveCartNote(noteValue, shouldRedirect) {
      const updateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/update.js'
        : '/cart/update.js';

      fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: noteValue
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        console.log('Cart note saved:', cart.note);

        // Only redirect if explicitly requested (from checkout button)
        if (shouldRedirect) {
          window.location.href = '/checkout';
        }
      })
      .catch(function(error) {
        console.error('Error saving cart note:', error);

        // Even on error, redirect if checkout button was clicked
        if (shouldRedirect) {
          window.location.href = '/checkout';
        }
      });
    }
  })();